import { render, staticRenderFns } from "./InfoSidebar.vue?vue&type=template&id=344c27da&scoped=true&"
import script from "./InfoSidebar.vue?vue&type=script&lang=js&"
export * from "./InfoSidebar.vue?vue&type=script&lang=js&"
import style0 from "./InfoSidebar.vue?vue&type=style&index=0&id=344c27da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344c27da",
  null
  
)

export default component.exports